/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React, { useState } from 'react'
import { useServiceContext } from '../../../root'
import ActionsMenu from '../../../components/shared/ActionsMenu'
import ModalImport from '../../../components/modals/ModalImport'

const PageMenu: React.FC<{ onAddDocumentType: () => void; onExportStart?: () => void; onExportEnd?: () => void }> = ({
  onAddDocumentType,
  onExportStart,
  onExportEnd
}) => {
  const context = useServiceContext()
  const { translate } = context.service.filter
  const { toast } = context.service
  const [showImportModal, setShowImportModal] = useState(false)

  const handleImport = () => {
    setShowImportModal(true)
  }

  const handleExport = async () => {
    try {
      // Start loading
      if (onExportStart) {
        onExportStart()
      }

      // Export all document type with DOCUMENT_TYPES entity parameter
      await context.api.settings.exportSettingsData('DOCUMENT_TYPES', undefined, undefined, translate)
    } catch (error) {
      toast.error(translate('SETTINGS_IMPORT_FAIL'))
    } finally {
      // End loading
      if (onExportEnd) {
        onExportEnd()
      }
    }
  }

  const settings = {
    menuId: 'page',
    items: [
      {
        value: 'SETTINGS_DOC_TYPES_ADD',
        action: onAddDocumentType
      },
      {
        value: 'SETTINGS_DOC_TYPES_IMPORT',
        action: handleImport
      },
      {
        value: 'SETTINGS_DOC_TYPES_EXPORT',
        action: handleExport
      }
    ],
    isBigMenu: true
  }

  return (
    <>
      <ActionsMenu {...settings} />
      {showImportModal && (
        <ModalImport
          importType={context.constant.system.settings.entities.DOCUMENT_TYPES}
          show={showImportModal}
          onClose={() => {
            setShowImportModal(false)
          }}
        />
      )}
    </>
  )
}

export default PageMenu
